export const SABBATICALS = "sabbaticals";